import { Currency } from '@uniswap/sdk-core'
import Row from 'components/Row'
import { useState } from 'react'
import { Share2 } from 'react-feather'
import styled, { keyframes } from 'styled-components/macro'

import ShareModal from './ShareModal'

const shareGlow = keyframes`
  0%, 100% {
    filter: drop-shadow(0 0 2px rgba(252, 114, 255, 0.4));
  }
  50% {
    filter: drop-shadow(0 0 8px rgba(252, 114, 255, 0.8));
  }
`

const Icon = styled(Share2)<{ $hasTokens?: boolean }>`
  height: 15px;
  width: 15px;
  > * {
    stroke: ${({ theme, $hasTokens }) => ($hasTokens ? theme.textSecondary : theme.textSecondary)};
  }
`

const Button = styled.button<{ disabled?: boolean }>`
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  outline: none;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};

  :not([disabled]):hover {
    opacity: 0.7;
  }
`

const IconContainer = styled(Row)`
  padding: 6px 8px 6px 6px;
  border-radius: 6px;
`

interface ShareButtonProps {
  inputCurrency?: Currency | null
  outputCurrency?: Currency | null
}

export default function ShareButton({ inputCurrency, outputCurrency }: ShareButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const hasTokens = Boolean(inputCurrency && outputCurrency)

  const handleClick = () => {
    if (hasTokens) {
      setIsModalOpen(true)
    }
  }

  const handleDismiss = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Button disabled={!hasTokens} onClick={handleClick} aria-label="Share swap route">
        <IconContainer>
          <Icon $hasTokens={hasTokens} />
        </IconContainer>
      </Button>
      <ShareModal
        isOpen={isModalOpen}
        onDismiss={handleDismiss}
        inputCurrency={inputCurrency}
        outputCurrency={outputCurrency}
      />
    </>
  )
}
